import { render, staticRenderFns } from "./editTrainingInstitutionMember.vue?vue&type=template&id=68db665a&scoped=true&"
import script from "./editTrainingInstitutionMember.vue?vue&type=script&lang=js&"
export * from "./editTrainingInstitutionMember.vue?vue&type=script&lang=js&"
import style0 from "./editTrainingInstitutionMember.vue?vue&type=style&index=0&id=68db665a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68db665a",
  null
  
)

export default component.exports